import { UserRole } from "components/User/constants";

export const AppRouteURI = Object.freeze({
  LANDING: "/",
  HOME: "/home",
  LOGIN: "/login",
  LOGOUT: "/logout",
  REGISTER: "/register",
  RESET_PWD: "/reset_password",
  INVITATION: "/invitation",
  MEMBERS: "/members",
  SECURITY: "/security",
  SETTINGS: "/settings",
  INVITES: "/invites",
});

export const AppRoutingRoles = Object.freeze({
  [AppRouteURI.LANDING]: {
    isProtected: false,
    checkRoles: [],
  },
  [AppRouteURI.HOME]: {
    isProtected: false,
    checkRoles: [],
  },
  [AppRouteURI.MEMBERS]: {
    isProtected: true,
    checkRoles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },
  [AppRouteURI.INVITES]: {
    isProtected: true,
    checkRoles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },
  [AppRouteURI.SECURITY]: {
    isProtected: true,
    checkRoles: [UserRole.SUPERADMIN],
  },
  [AppRouteURI.SETTINGS]: {
    isProtected: true,
    checkRoles: [],
  },
});
